import { Card, CardContent } from 'easyship-components';
import { FormattedMessage } from 'react-intl';

import { usePaymentIntentContext } from '@/providers/PaymentIntentProvider/context';
import InsuranceSVG from '@/svg/Insurance.svg';
import { API } from '@/utils/apiConstants';

import { Link } from './Link';

export const AddShippingInsuranceCard = () => {
  const {
    data: { insurance_fee, insured_value },
  } = usePaymentIntentContext();

  return (
    <Card className="border-2 border-green-500">
      <CardContent>
        <div className="flex items-start gap-2">
          <div className="flex shrink-0 size-6 items-center justify-center">
            <img src={InsuranceSVG} alt="insurance" />
          </div>
          <div>
            <FormattedMessage
              id="add-shipping-insurance.message"
              values={{
                cost: insurance_fee,
                amount: insured_value,
              }}
            />{' '}
            <Link href={API.supportUrl} className="italic">
              <FormattedMessage id="global.learn-more" />
            </Link>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
